<template>
  <v-container>
    <v-card>
      <v-toolbar>
        <v-toolbar-title>Complete Account Details</v-toolbar-title>
      </v-toolbar>
      <v-container>
        <v-form v-model="sign_up_form" ref="sign_up_form">
          <v-text-field
              label="User Name"
              v-model="user.user_name"
              :rules="[rules.required]"
          />
          <v-text-field
              label="First Name"
              v-model="user.first_name"
              :rules="[rules.required]"
          />
          <v-text-field
            label="Last Name"
            v-model="user.last_name"
            :rules="[rules.required]"
        />
          <v-text-field
              label="Phone No."
              v-model="user.phone"
              :rules="[rules.required]"
          />
          <v-text-field
              label="Date of birth"
              v-model="user.dob"
              type="date"
          />
          <v-select
              v-model="user.gender"
              label="Select Gender"
              :items="gender_opts"
          />
          <v-text-field
              label="Email"
              v-model="user.email"
              readonly
              :rules="[rules.required]"
          />
        </v-form>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="$emit('close')">Cancel</v-btn>
          <v-btn color="success" @click="updateUser" :loading="loading">Done</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "CompleteSignUp",
  data() {
    return {
      loading: false,
      sign_up_form: false,
      user: {
        user_name: '',
        first_name: '',
        last_name: '',
        phone: '',
        dob: '',
        gender: '',
        status: 'ACTIVE',
        level: 1
      },
      gender_opts: [
          'Male',
          'Female',
          'Other',
      ],
      rules: {
        required: v => !!v || 'Required field'
      }
    }
  },
  methods: {
    async updateUser() {
      this.loading = !this.loading
      if (this.$refs.sign_up_form.validate()) {
        await this.$store.dispatch('UPDATE_USER', this.user)
        if (this.$store.getters.user.first_name) {
          await this.$router.push('/dashboard')
        }
      }
      this.loading = !this.loading
    }
  },
  created() {
    this.user = {
      ...this.user,
      ...this.$store.getters.user
    }
  }
}
</script>

<style scoped>

</style>